import { Wire } from '@/v2/v3/Wire'

// /signals renders the v3 "The Wire" surface (App.jsx imports this as
// V2SignalsPage). The legacy AppLayout-based composition was trimmed in
// the B4 cleanup — see git history.
export default function SignalsPage() {
  return <Wire />
}
